<template>
  <div class="m_base">
    <ul>
      <li v-for="member in members" :key="member.email" class="container">
        <div class="left">
          <p >{{member.email}}</p>
        </div>
        <div v-if="isApearDelete" @click="deleteMember(member.id)" class="delete _eg">Delete</div>
      </li>
    </ul>
    <div v-if="!isApearDelete" @click="changeMode()" class="m_go _eg">Edit Member</div>
  </div>
</template>

<script>

import "@/css/manager.css"
import {db} from '@/firebase/index.js'

export default {
  components:{

  },
  props:{
    is_sign: Boolean
  },
  data(){
    return{
      pageName: "member",
      isError: false,
      isApearDelete: false,

      members:[],

    }
  },
  beforeCreate(){

  },
  created(){
    this.$store.commit('managerPageName', this.pageName)
    if(!this.is_sign){
      this.$router.push({name: 'Manager'})
    }
    db.collection('member').orderBy('createdAt', 'desc').get()
    .then((querySnapShot)=>{
      querySnapShot.forEach(doc => {
        this.members.push(doc.data())   
      });
    })

  },
  mounted(){

  },
  methods:{
    deleteMember(id){
      db.collection('member').doc(id).delete()
      .then(()=>{
        this.$router.go({path: this.$router.currentRoute.path, force: true})
      })
    },
    changeMode(){
      this.isApearDelete = true
    }
  },
  watch: {

  },
  computed:{

  },

}
</script>


<style scoped>
ul {
  margin-bottom: 50px;
}
.container{
  display: flex;
  justify-content: space-between;
  height: 20px;
  margin-bottom: 30px;
}
.container:hover{
  box-sizing: border-box;
  border-bottom: 1px solid var(--black);
}
.left{
  display: flex;
}
.left p{
  line-height: 20px;
  margin-right: 10px;
}

.delete{
  background-color: brown;
  color: var(--white);
  display: block;
  width: 50px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 1.2rem;
  opacity: 0.6;
  cursor: pointer;
}
.delete:hover{
  opacity: 1;
}


@media screen and (min-width:600px){

}

</style>